import * as React from "react";
import {
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  LinearProgress
} from "@material-ui/core";
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { QueryFilter, QUERY_FILTER_MARKET, ShowShareTable } from 'src/component/shared';


const MARKET_RANKING_PUBLISHERS = gql`
query marketShareRankingPublishers($customFilter:  MarketShareCustomFilter) {
    marketShareRankingPublishers(marketShareCustomFilter: $customFilter) {
        name,
        value
    }
}
`;

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareRankingPublishersModalProps {
    type: string;
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareRankingPublishersModalState {
  dialogOpen: boolean;
}

export class MarketShareRankingPublishersModal extends React.Component<IMarketShareRankingPublishersModalProps, 
    IMarketShareRankingPublishersModalState> {
    constructor(props: IMarketShareRankingPublishersModalProps) {
        super(props);
        this.state = {
            dialogOpen: false
        };
    }

    public render() {

        const jsonFilter = {
            "customFilter": {
              "isChart": true,
              "type": this.props.type,
            }
        };

        return (
            <div className="filter-item">
                <Query query={QUERY_FILTER_MARKET} notifyOnNetworkStatusChange={true}  >
                    {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {
                        return (
                            <Query query={MARKET_RANKING_PUBLISHERS} variables={QueryFilter.getFilterMarket(clientC, jsonFilter, ['provider','stamp'], false)} >
                                {({ loading, error, data, client}) => {
                                    return this.dataToRend(data, loading);
                                }}
                            </Query>
                        );
                    }}
                </Query>
            </div>
        );
    }

    private dataToRend (data:any, loading:any) {
        return (
            <div>
            {loading ? 
                <LinearProgress /> : 
                <div>
                    {data && data.marketShareRankingPublishers && <div>
                        <Button onClick={this.handleDialogOpen} color="primary">
                            Ver Mais
                        </Button>
                        <Dialog
                            fullScreen={true}
                            open={this.state.dialogOpen}
                            onClose={this.handleDialogClose}
                            aria-labelledby="share-table-modal-group-dialog-title"
                            aria-describedby="share-table-modal-group-dialog-description"
                            className="share-table-modal-dialog"
                        >
                            <DialogTitle
                                className="share-table-modal-dialog-title"
                                id="share-table-modal-group-dialog-title"
                            >
                                Ranking Editoras - 30 Dias
                            </DialogTitle>
                            <DialogContent className="share-table-modal-dialog-content">
                                <Paper className="shared-share-sharetablemodal-block panel-block">
                                    <Grid container={true} spacing={16}>
                                        <ShowShareTable data={data.marketShareRankingPublishers} />
                                    </Grid>
                                </Paper>
                            </DialogContent>
                            <DialogActions className="share-table-modal-actions">
                                <Button
                                    className="filter-dialog-close"
                                    onClick={this.handleDialogClose}
                                >
                                    Fechar
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>}
                </div>
            }
            </div>
        );
    }

  private handleDialogOpen = () => {
    this.setState({ dialogOpen: true });
  };

  private handleDialogClose = () => {
    this.setState({ dialogOpen: false });
  };
}



// WEBPACK FOOTER //
// ./src/component/market/general/publishers/shared/ranking/MarketShareRankingPublishersModal.tsx